module.exports = __webpack_public_path__ + "static/media/logo.9725d5d6.svg";